// extracted by mini-css-extract-plugin
module.exports = {"activeTab":"DevicesTabsMainPanel__activeTab","tabLink":"DevicesTabsMainPanel__tabLink","tabNav":"DevicesTabsMainPanel__tabNav"};